var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"text-reader"},[_vm._v(" Select File "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.loadTextFromFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }